var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.509254 6.13296e-06C0.373968 -0.000691676 0.24413 0.0581841 0.149064 0.163336C-0.0496881 0.380727 -0.0496881 0.7329 0.149064 0.950291L4.77037 5.99868L0.149064 11.0471C-0.0496881 11.2645 -0.0496881 11.6166 0.149064 11.834C0.243725 11.9401 0.373614 12 0.509254 12C0.644894 12 0.774783 11.9401 0.869444 11.834L5.85094 6.39216C6.04969 6.17476 6.04969 5.82259 5.85094 5.6052L0.869444 0.163336C0.774378 0.0581841 0.64454 -0.000691676 0.509254 6.13296e-06Z",
    fill: "#139FC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50925 6.13296e-06C5.37397 -0.000691676 5.24413 0.0581841 5.14906 0.163336C4.95031 0.380727 4.95031 0.7329 5.14906 0.950291L9.77037 5.99868L5.14906 11.0471C4.95031 11.2645 4.95031 11.6166 5.14906 11.834C5.24372 11.9401 5.37361 12 5.50925 12C5.64489 12 5.77478 11.9401 5.86944 11.834L10.8509 6.39216C11.0497 6.17476 11.0497 5.82259 10.8509 5.6052L5.86944 0.163336C5.77438 0.0581841 5.64454 -0.000691676 5.50925 6.13296e-06Z",
    fill: "#139FC8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/double-arrow-right.a39a63f5cea398ef21a9e3adb8c5cad8.svg";